import {  createContext } from "react";


export const PicaPontoContext = createContext<{modoPicaPonto: boolean, setModoPicaPonto: any}>({ modoPicaPonto: false, setModoPicaPonto: null});